export const STATE_EXPIRED_EVENT_ID = -1;
export const STATE_EXPIRED_EVENT_NAME = "stateTimer";
export const BEADL_EDGE = "beadlEdge";
